import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useCall } from '@/contexts/call-context';
import { useAuth } from '@/contexts/auth-context';
import ringbackUrl from '@assets/Videocall_Rinback_long_1777302464110.mp3';

interface AudioSettings {
  audioNotificationsEnabled: boolean;
}

export function RingbackPlayer() {
  const { activeCall, remoteParticipants } = useCall();
  const { user } = useAuth();
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const isInitiator = !!activeCall && user?.id === activeCall.session.initiatorUserId;
  const isWaitingForAnyone = isInitiator && remoteParticipants.length === 0;

  const { data: audioSettings } = useQuery<AudioSettings>({
    queryKey: ['/api/user/audio-settings'],
    enabled: isWaitingForAnyone,
  });
  const soundEnabled = audioSettings?.audioNotificationsEnabled ?? false;

  const shouldRingback = isWaitingForAnyone && soundEnabled;

  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    if (shouldRingback) {
      a.loop = true;
      a.volume = 0.5;
      a.play().catch(() => undefined);
    } else {
      a.pause();
      a.currentTime = 0;
    }
    return () => {
      if (a) { a.pause(); a.currentTime = 0; }
    };
  }, [shouldRingback]);

  if (!activeCall || !isInitiator) return null;

  return <audio ref={audioRef} src={ringbackUrl} preload="auto" />;
}
